// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__2Bn9y","colCheckbox":"styles_colCheckbox__36Pdz"};